const TABLET_BREAKPOINT = 768;
const LARGE_TABLET_BREAKPOINT = 992;
const DESKTOP_BREAKPOINT = 1024;

export { TABLET_BREAKPOINT, LARGE_TABLET_BREAKPOINT, DESKTOP_BREAKPOINT };
